import { getLocalizedStrings } from '../misc';
import {
  EnhancedPromo$19,
  EnhancedPromo$20,
  EnhancedPromo$22,
  EnhancedPromo$24,
  EnhancedPromo$26,
  CompletePromo$25,
  CompletePromo$26,
  CompletePromo$27,
  CompletePromo$29,
  CompletePromo$31,
  CompletePromo$33,
  EnhancedPromoSeat$19,
  EnhancedPromoSeat$20,
  EnhancedPromoSeat$22,
  EnhancedPromoSeat$24,
  EnhancedPromoSeat$26,
  CompletePromoSeat$25,
  CompletePromoSeat$26,
  CompletePromoSeat$27,
  CompletePromoSeat$29,
  CompletePromoSeat$31,
  CompletePromoSeat$33,
  EnhancedBundled26_3MF,
  CompleteBundled26_3MF,
  EnhanceBundled26_3MF_Multi,
  CompleteBundled26_3MF_Multi,
  multiUnitDiscount$2,
  multiUnitDiscount$4,
  multiUnitDiscount$6,
  multiUnitDiscount$7,
  multiUnitDiscount$8,
  allowedProvinceQCBundle
} from './constant';

const {
  contentfulValues: {
    devicePolycomVVX150,
    devicePolyEdgeE220,
    devicePolycomVVX350,
    deviceYealinkT42S,
    deviceYealinkT48U,
    deviceYealinkT34W,
    deviceYealinkT34WOld,
    deviceYealinkT48UOld,
    deviceYealinkT33G,
    deviceYealinkT33GOld,
    devicePolyEdgeE100,
    deviceYealinkT53W,
    deviceYealinkT53WOld,
    editionMapping: { mobile, voicePlus, enhanced, complete }
  }
} = getLocalizedStrings();

export const promoDeviceRate = 0.99;

export const hwcPromoDeviceRates = {
  [devicePolycomVVX150]: 0.01,
  [devicePolyEdgeE220]: 40,
  [devicePolycomVVX350]: 75,
  [deviceYealinkT42S]: 25,
  [deviceYealinkT48U]: 110,
  [deviceYealinkT48UOld]: 110,
  [deviceYealinkT34W]: 0.01,
  [deviceYealinkT34WOld]: 0.01,
  [deviceYealinkT33G]: 0.01,
  [deviceYealinkT33GOld]: 0.01,
  [devicePolyEdgeE100]: 10,
  [deviceYealinkT53W]: 87,
  [deviceYealinkT53WOld]: 87
};

export const rsiLicencesRate = {
  100: 220,
  250: 285,
  500: 355,
  1000: 495,
  2000: 785,
  3000: 1065
};

export const genesisLicencesRate = {
  35: 53,
  50: 70,
  75: 100,
  100: 120,
  150: 160,
  225: 190,
  300: 210,
  500: 260,
  1000: 280,
  1500: 315,
  3000: 345,
  5000: 465
};

export const ENHANCED_COMPLETE_SEAT_PROMO_RATES = {
  [EnhancedPromo$20]: 20,
  [EnhancedPromo$19]: 19,
  [EnhancedPromo$22]: 22,
  [EnhancedPromo$24]: 24,
  [EnhancedPromo$26]: 26,
  [CompletePromo$25]: 25,
  [CompletePromo$26]: 26,
  [CompletePromo$27]: 27,
  [CompletePromo$29]: 29,
  [CompletePromo$31]: 31,
  [CompletePromo$33]: 33,
  [EnhancedPromoSeat$20]: 20,
  [EnhancedPromoSeat$19]: 19,
  [EnhancedPromoSeat$22]: 22,
  [EnhancedPromoSeat$24]: 24,
  [EnhancedPromoSeat$26]: 26,
  [CompletePromoSeat$25]: 25,
  [CompletePromoSeat$26]: 26,
  [CompletePromoSeat$27]: 27,
  [CompletePromoSeat$29]: 29,
  [CompletePromoSeat$31]: 31,
  [CompletePromoSeat$33]: 33,
  [EnhancedBundled26_3MF]: 26,
  [CompleteBundled26_3MF]: 28,
  [EnhanceBundled26_3MF_Multi]: 26,
  [CompleteBundled26_3MF_Multi]: 28,
  [multiUnitDiscount$2]: 2,
  [multiUnitDiscount$4]: 4,
  [multiUnitDiscount$6]: 6,
  [multiUnitDiscount$7]: 7,
  [multiUnitDiscount$8]: 8
};

export const editionPriceForOdysseyAI = {
  [mobile]: 25,
  [voicePlus]: 35,
  [enhanced]: 40,
  [complete]: 45
};

export const seatRatePrice = {
  Commercial: {
    Amélioré: (province, serviceProvince, month) => ({
      bundled: '30',
      nonBundled: '35'
    }),
    Complet: (province, serviceProvince, month) => ({
      bundled: '40',
      nonBundled: '45'
    }),
    'Complet PLUS': (province, serviceProvince, month) => ({
      bundled: '60',
      nonBundled: '65'
    }),
    Complete: (province, serviceProvince, month) => ({
      bundled: '40',
      nonBundled: '45'
    }),
    'Complete +': (province, serviceProvince, month) => ({
      bundled: '60',
      nonBundled: '65'
    }),
    Enhanced: (province, serviceProvince, month) => ({
      bundled: '30',
      nonBundled: '35'
    }),

    'Espace d’affaires intelligent – Amélioré': (
      province,
      serviceProvince,
      month
    ) => ({ bundled: '30', nonBundled: '30' }),
    'Espace d’affaires intelligent – Complet': (
      province,
      serviceProvince,
      month
    ) => ({ bundled: '35', nonBundled: '35' }),
    'Espace d’affaires intelligent – Complet PLUS': (
      province,
      serviceProvince,
      month
    ) => ({ bundled: '45', nonBundled: '45' }),

    Mobile: (province, serviceProvince, month) => ({
      bundled: '15',
      nonBundled: '20'
    }),
    Voice: (province, serviceProvince, month) => ({
      bundled: '20',
      nonBundled: '25'
    }),
    'Voice +': (province, serviceProvince, month) => ({
      bundled: '25',
      nonBundled: '30'
    }),
    Voix: (province, serviceProvince, month) => ({
      bundled: '20',
      nonBundled: '25'
    }),
    'Voix PLUS': (province, serviceProvince, month) => ({
      bundled: '25',
      nonBundled: '30'
    }),

    'Workplace Complete': (province, serviceProvince, month) => ({
      bundled: '35',
      nonBundled: '35'
    }),
    'Workplace Complete +': (province, serviceProvince, month) => ({
      bundled: '45',
      nonBundled: '45'
    }),
    'Workplace Enhanced': (province, serviceProvince, month) => ({
      bundled: '30',
      nonBundled: '30'
    })
  },

  // --------------------------------------------------------
  // SMB (1-30)
  // --------------------------------------------------------
  'SMB (1-30)': {
    Amélioré: (province, serviceProvince, month) => {
      const isQC = allowedProvinceQCBundle.includes(province) && allowedProvinceQCBundle.includes(serviceProvince);
      if (['Month-to-Month', 'sur une base mensuelle'].includes(month))
        return isQC ? { bundled: '30', nonBundled: '40' } : { bundled: '35', nonBundled: '40' };
      return isQC ? { bundled: '25', nonBundled: '35' } : { bundled: '30', nonBundled: '35' };
    },

    Complet: (province, serviceProvince, month) => {
      const isQC = allowedProvinceQCBundle.includes(province) && allowedProvinceQCBundle.includes(serviceProvince);
      if (['Month-to-Month', 'sur une base mensuelle'].includes(month))
        return isQC ? { bundled: '35', nonBundled: '45' } : { bundled: '40', nonBundled: '45' };
      return isQC ? { bundled: '30', nonBundled: '40' } : { bundled: '35', nonBundled: '40' };
    },

    'Complet PLUS': (province, serviceProvince, month) => ({
      bundled: '50',
      nonBundled: '60'
    }),

    Complete: (province, serviceProvince, month) => {
      const isQC = allowedProvinceQCBundle.includes(province) && allowedProvinceQCBundle.includes(serviceProvince);
      if (['Month-to-Month', 'sur une base mensuelle'].includes(month))
        return isQC ? { bundled: '35', nonBundled: '45' } : { bundled: '40', nonBundled: '45' };
      return isQC ? { bundled: '30', nonBundled: '40' } : { bundled: '35', nonBundled: '40' };
    },

    'Complete +': (province, serviceProvince, month) => ({
      bundled: '50',
      nonBundled: '60'
    }),

    Enhanced: (province, serviceProvince, month) => {
      const isQC = allowedProvinceQCBundle.includes(province) && allowedProvinceQCBundle.includes(serviceProvince);
      if (['Month-to-Month', 'sur une base mensuelle'].includes(month))
        return isQC ? { bundled: '30', nonBundled: '40' } : { bundled: '35', nonBundled: '40' };
      return isQC ? { bundled: '25', nonBundled: '35' } : { bundled: '30', nonBundled: '35' };
    },

    Mobile: (province, serviceProvince, month) => {
      if (['Month-to-Month', 'sur une base mensuelle'].includes(month))
        return { bundled: '20', nonBundled: '25' };
      return { bundled: '15', nonBundled: '20' };
    },

    Voice: (province, serviceProvince, month) => ({
      bundled: '20',
      nonBundled: '25'
    }),

    'Voice +': (province, serviceProvince, month) => {
      const isQC = allowedProvinceQCBundle.includes(province) && allowedProvinceQCBundle.includes(serviceProvince);
      if (['Month-to-Month', 'sur une base mensuelle'].includes(month))
        return isQC ? { bundled: '25', nonBundled: '35' } : { bundled: '30', nonBundled: '35' };
      return isQC ? { bundled: '20', nonBundled: '30' } : { bundled: '25', nonBundled: '30' };
    },

    Voix: (province, serviceProvince, month) => ({
      bundled: '20',
      nonBundled: '25'
    }),

    'Voix PLUS': (province, serviceProvince, month) => {
      const isQC = allowedProvinceQCBundle.includes(province) && allowedProvinceQCBundle.includes(serviceProvince);
      if (['Month-to-Month', 'sur une base mensuelle'].includes(month))
        return isQC ? { bundled: '25', nonBundled: '35' } : { bundled: '30', nonBundled: '35' };
      return isQC ? { bundled: '20', nonBundled: '30' } : { bundled: '25', nonBundled: '30' };
    }
  },

  // --------------------------------------------------------
  // SMB (30-100)
  // --------------------------------------------------------
  'SMB (30-100)': {
    Amélioré: (province, serviceProvince, month) => {
      const isQC = allowedProvinceQCBundle.includes(province) && allowedProvinceQCBundle.includes(serviceProvince);
      if (['Month-to-Month', 'sur une base mensuelle'].includes(month))
        return isQC ? { bundled: '30', nonBundled: '40' } : { bundled: '35', nonBundled: '40' };
      return isQC ? { bundled: '25', nonBundled: '35' } : { bundled: '30', nonBundled: '35' };
    },

    Complet: (province, serviceProvince, month) => {
      const isQC = allowedProvinceQCBundle.includes(province) && allowedProvinceQCBundle.includes(serviceProvince);
      if (['Month-to-Month', 'sur une base mensuelle'].includes(month))
        return isQC ? { bundled: '35', nonBundled: '45' } : { bundled: '40', nonBundled: '45' };
      return isQC ? { bundled: '30', nonBundled: '40' } : { bundled: '35', nonBundled: '40' };
    },

    'Complet PLUS': (province, serviceProvince, month) => ({
      bundled: '50',
      nonBundled: '60'
    }),

    Complete: (province, serviceProvince, month) => {
      const isQC = allowedProvinceQCBundle.includes(province) && allowedProvinceQCBundle.includes(serviceProvince);
      if (['Month-to-Month', 'sur une base mensuelle'].includes(month))
        return isQC ? { bundled: '35', nonBundled: '45' } : { bundled: '40', nonBundled: '45' };
      return isQC ? { bundled: '30', nonBundled: '40' } : { bundled: '35', nonBundled: '40' };
    },

    'Complete +': (province, serviceProvince, month) => ({
      bundled: '50',
      nonBundled: '60'
    }),

    Enhanced: (province, serviceProvince, month) => {
      const isQC = allowedProvinceQCBundle.includes(province) && allowedProvinceQCBundle.includes(serviceProvince);
      if (['Month-to-Month', 'sur une base mensuelle'].includes(month))
        return isQC ? { bundled: '30', nonBundled: '40' } : { bundled: '35', nonBundled: '40' };
      return isQC ? { bundled: '25', nonBundled: '35' } : { bundled: '30', nonBundled: '35' };
    },

    'Espace d’affaires intelligent – Amélioré': (
      province,
      serviceProvince,
      month
    ) => ({ bundled: '30', nonBundled: '30' }),
    'Espace d’affaires intelligent – Complet': (
      province,
      serviceProvince,
      month
    ) => ({ bundled: '35', nonBundled: '35' }),
    'Espace d’affaires intelligent – Complet PLUS': (
      province,
      serviceProvince,
      month
    ) => ({ bundled: '45', nonBundled: '45' }),

    Mobile: (province, serviceProvince, month) => {
      if (['Month-to-Month', 'sur une base mensuelle'].includes(month))
        return { bundled: '20', nonBundled: '25' };
      return { bundled: '15', nonBundled: '20' };
    },

    Voice: (province, serviceProvince, month) => ({
      bundled: '20',
      nonBundled: '25'
    }),

    'Voice +': (province, serviceProvince, month) => {
      const isQC = allowedProvinceQCBundle.includes(province) && allowedProvinceQCBundle.includes(serviceProvince);
      if (['Month-to-Month', 'sur une base mensuelle'].includes(month))
        return isQC ? { bundled: '25', nonBundled: '35' } : { bundled: '30', nonBundled: '35' };
      return isQC ? { bundled: '20', nonBundled: '30' } : { bundled: '25', nonBundled: '30' };
    },

    Voix: () => ({ bundled: '20', nonBundled: '25' }),

    'Voix PLUS': (province, serviceProvince, month) => {
      const isQC = allowedProvinceQCBundle.includes(province) && allowedProvinceQCBundle.includes(serviceProvince);
      if (['Month-to-Month', 'sur une base mensuelle'].includes(month))
        return isQC ? { bundled: '25', nonBundled: '35' } : { bundled: '30', nonBundled: '35' };
      return isQC ? { bundled: '20', nonBundled: '30' } : { bundled: '25', nonBundled: '30' };
    },

    'Workplace Complete': (province, serviceProvince, month) => ({
      bundled: '35',
      nonBundled: '35'
    }),
    'Workplace Complete +': (province, serviceProvince, month) => ({
      bundled: '45',
      nonBundled: '45'
    }),
    'Workplace Enhanced': (province, serviceProvince, month) => ({
      bundled: '30',
      nonBundled: '30'
    })
  }
};
